import { useEffect, useRef,useState, useContext } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  Stack,
  Button,
  Typography
} from '@mui/material';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Modal from 'react-bootstrap/Modal';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import BreadcrumbsWrapper from '../../../components/breadcrumbs'


function MyVerticallyCenteredModal({ show, onHide, authToken, onCustomerAdd }) {
  const [searchFields, setSearchFields] = useState({
    title: '',
    forename: '',
    surname: '',
    email: '',
    phone_number: ''
  });
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef();

  const fetchCustomerSearch = async () => {
    const isEmpty = Object.values(searchFields).every(v => !v);
    if (isEmpty) {
      setSearchResults([]);
      return;
    }

    try {
      setLoading(true);
      const res = await postRequest('private/leadsCustomerList', searchFields, authToken);
      setSearchResults(res?.data || []);
    } catch (err) {
      console.error('Error fetching search:', err);
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(fetchCustomerSearch, 400);
    return () => clearTimeout(debounceRef.current);
  }, [searchFields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateCustomer = async () => {
    try {
      setLoading(true);
      const res = await postRequest('private/createCustomer', searchFields, authToken);
      if (res?.status === 200 || res?.status === 'success' || (res?.data && res.data._id)) {
        Swal.fire('Success', 'Customer created successfully!', 'success');
        const newCustomer = res.data;
        onCustomerAdd(newCustomer);
        onHide();
        setSearchFields({ title: '', forename: '', surname: '', email: '', phone_number: '' });
      }
    } catch (err) {
      Swal.fire('Error', err?.message || 'Something went wrong', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Customers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='m-0'>
          {['title', 'forename', 'surname', 'email', 'phone_number'].map((field, idx) => (
            <Col xs={field === 'email' || field === 'phone_number' ? 6 : 4} key={idx}>
              <Box sx={{ '& > :not(style)': { m: 1, width: '100%' } }}>
                <TextField
                  label={field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')}
                  name={field}
                  value={searchFields[field]}
                  onChange={handleChange}
                  variant="outlined"
                  type={field === 'email' ? 'email' : field === 'phone_number' ? 'tel' : 'text'}
                />
              </Box>
            </Col>
          ))}
        </Row>

        <Row className='mt-4'>
          <Col>
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Add</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="4" className='text-center'>Loading...</td></tr>
                ) : searchResults.length > 0 ? (
                  searchResults.map((customer) => (
                    <tr key={customer._id}>
                      <td>{customer.title} {customer.forename} {customer.surname}</td>
                      <td>{customer.email}</td>
                      <td>{customer.phone_number}</td>
                      <td>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            onCustomerAdd(customer);
                            onHide();
                          }}
                        >
                          Add
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="4" className='text-center'>No customers found</td></tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
        {!loading && searchResults.length === 0 && Object.values(searchFields).some(v => v) && (
          <Row className='mt-3'>
            <Col className='text-center'>
              <Button
                variant="contained"
                startIcon={<PersonAddOutlinedIcon />}
                onClick={handleCreateCustomer}
                sx={{
                  backgroundColor: '#6f42c1',
                  '&:hover': {
                    backgroundColor: '#5a32a3'
                  }
                }}
              >
                Add Customer
              </Button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
}

const EditLeadForm = () => {
  console.log('edit-state@12345678')
  const { lead_id, slug } = useParams();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const [groupCodes, setGroupCodes] = useState([]);
    const [productId, setProductId] = useState('');
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [customerError, setCustomerError] = useState(false);
  const [lenderPanels, setLenderPanels] = useState([]);
  const [partners, setPartners] = useState([]);


  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      group_code: '',
      acquisition: '',
      net_value: '',
      lender_panel_id: '',
      partner_id: '',
    },
  });

  const handleCustomerAdd = (customer) => {
    if (!selectedCustomers.some((c) => c._id === customer._id)) {
      setSelectedCustomers((prev) => [...prev, customer]);
      setCustomerError(false);
    }
  };

  const fetchGroupCodes = async () => {
    try {
      const res = await postRequest('private/getGroupCodeList', {}, authCtx.token);
      if (res?.status === 200 && Array.isArray(res.data)) {
        setGroupCodes(res.data);
      }
    } catch (err) {
      console.error('Error fetching group codes:', err);
    }
  };

  const fetchLenderPanels = async () => {
    try {
      const response = await postRequest('private/getActiveLenderPanels', {}, authCtx.token);
      if (response?.status === 200 && response?.data) {
        setLenderPanels(response.data);
      }
    } catch (error) {
      console.error('Error fetching lender panels:', error);
    }
  };

  const fetchPartners = async () => {
    try {
      const response = await postRequest('private/partnerList', { page: 1, limit: 100 }, authCtx.token);
      if (response?.data?.docs) {
        setPartners(response.data.docs);
      }
    } catch (error) {
      console.error('Error fetching partners:', error);
    }
  };

  const fetchLeadDetails = async () => {
    try {
      const res = await postRequest(`private/get-single-lead/${lead_id}`, {}, authCtx.token);
      const lead = res?.data;

      console.log(lead , 'leads----')

      if (lead) {
        reset({
          group_code: lead.group_code?._id ? String(lead.group_code._id) : '',
          acquisition: lead.acquisition || '',
          net_value: lead.net_value || '',
          lender_panel_id: lead.lender_panel_id?._id ? String(lead.lender_panel_id._id) : (typeof lead.lender_panel_id === 'string' ? lead.lender_panel_id : ''),
          partner_id: lead.partner_id?._id ? String(lead.partner_id._id) : (typeof lead.partner_id === 'string' ? lead.partner_id : ''),
        });

        setSelectedCustomers(lead.customers || []);
        setProductId(lead.product_id?._id || '');
      }
    } catch (err) {
      console.error('Error fetching lead:', err);
    }
  };

  useEffect(() => {
    fetchGroupCodes();
    fetchLeadDetails();
    fetchLenderPanels();
    fetchPartners();
  }, [lead_id]);

  const onSubmit = async (formData) => {
    if (selectedCustomers.length === 0) {
      setCustomerError(true);
      return;
    }

    const payload = {
      ...formData,
      product_id: productId,
      created_id: localStorage.getItem('id'),
      customer_ids: selectedCustomers.map((c) => c._id),
      lender_panel_id: formData.lender_panel_id || null,
      partner_id: formData.partner_id || null,
    };

    try {
      const res = await postRequest(`private/lead-edit/${lead_id}`, payload, authCtx.token);
      if (res?.status === 'success') {
        Swal.fire('Success', 'Lead updated successfully!', 'success');
        navigate('/leads');
      } else {
        Swal.fire('Error', res?.message || 'Update failed', 'error');
      }
    } catch (err) {
      Swal.fire('Error', err?.message || 'Something went wrong', 'error');
    }
  };
    const slugToTitle = (slug) => {
  return slug
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

  const readableTitle = slugToTitle(slug || '');

  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Leads', path: '/leads' },
          { label: 'Edit Estate Administration', path: '' },
        ]}
      />
      <br />
      <br />
      <h2>Edit {readableTitle} #{lead_id}</h2>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col xs={12} md={6}>
            <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Group Code</h5>
            <Controller
              name="group_code"
              control={control}
              rules={{ required: 'Group Code is required' }}
              render={({ field }) => (
                <FormControl fullWidth error={!!errors.group_code}>
                  <InputLabel>Group Code</InputLabel>
                  <Select {...field} label="Group Code" value={field.value}>
                    {groupCodes.map((item) => (
                      <MenuItem key={item._id} value={String(item._id)}>
                        {`${item.name} (${item.code})`}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.group_code && (
                    <p style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>{errors.group_code.message}</p>
                  )}
                </FormControl>
              )}
            />
          </Col>

          <Col xs={12} md={6}>
            <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Acquisition</h5>
            <Controller
              name="acquisition"
              control={control}
              rules={{ required: 'Acquisition is required' }}
              render={({ field }) => (
                <FormControl fullWidth error={!!errors.acquisition}>
                  <InputLabel>Acquisition</InputLabel>
                  <Select {...field} label="Acquisition" value={field.value}>
                    <MenuItem value="Inbound">Inbound</MenuItem>
                    <MenuItem value="Cold-Acquistion">Cold-Acquistion</MenuItem>
                  </Select>
                  {errors.acquisition && (
                    <p style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>{errors.acquisition.message}</p>
                  )}
                </FormControl>
              )}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={12}>
            <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Net Estate Value</h5>
            <Controller
              name="net_value"
              control={control}
              rules={{
                required: 'Net Estate Value is required',
                validate: (val) => val > 0 || 'Value must be greater than 0',
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Net Estate Value"
                  sx={{ width: '100%' }}
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">£</InputAdornment>,
                  }}
                  error={!!errors.net_value}
                  helperText={errors.net_value?.message}
                />
              )}
            />
          </Col>
        </Row>

        {/* Lender Panel & Partner Section */}
        <Row className="mb-3">
          <Col xs={12} md={6}>
            <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Lender Panel</h5>
            <Controller
              name="lender_panel_id"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth>
                  <Select
                    {...field}
                    displayEmpty
                    sx={{ backgroundColor: 'white' }}
                  >
                    <MenuItem value="">
                      <em>Select Lender Panel (Optional)</em>
                    </MenuItem>
                    {lenderPanels.map((panel) => (
                      <MenuItem key={panel._id} value={panel._id}>
                        {panel.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Partner</h5>
            <Controller
              name="partner_id"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth>
                  <Select
                    {...field}
                    displayEmpty
                    sx={{ backgroundColor: 'white' }}
                  >
                    <MenuItem value="">
                      <em>Select Partner (Optional)</em>
                    </MenuItem>
                    {partners.map((partner) => (
                      <MenuItem key={partner._id} value={partner._id}>
                        {partner.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={12}>
            <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Customers</h5>
            {customerError && (
              <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                Please select at least one customer.
              </Alert>
            )}
            {selectedCustomers.length > 0 && (
              selectedCustomers.map((customer) => (
                <Box
                  key={customer._id}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2,
                    mb: 2,
                    border: '1px solid #e0e0e0',
                    borderRadius: 1,
                    backgroundColor: 'white'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {customer.title} {customer.forename} {customer.surname}
                    </Typography>
                    {customer.email && (
                      <Typography variant="body2" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        📧 {customer.email}
                      </Typography>
                    )}
                    {customer.phone_number && (
                      <Typography variant="body2" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        📞 {customer.phone_number}
                      </Typography>
                    )}
                  </Box>
                  <Button
                    size="small"
                    onClick={() =>
                      setSelectedCustomers((prev) =>
                        prev.filter((c) => c._id !== customer._id)
                      )
                    }
                    sx={{
                      minWidth: 'auto',
                      color: '#d32f2f',
                      '&:hover': {
                        backgroundColor: '#ffebee'
                      }
                    }}
                  >
                    ✕
                  </Button>
                </Box>
              ))
            )}
            <Button
              variant="text"
              startIcon={<PersonAddOutlinedIcon />}
              onClick={() => setModalShow(true)}
              sx={{
                color: '#6f42c1',
                textTransform: 'uppercase',
                fontWeight: 'normal',
                justifyContent: 'flex-start',
                pl: 0
              }}
            >
              Add Customer
            </Button>
          </Col>
          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            authToken={authCtx.token}
            onCustomerAdd={handleCustomerAdd}
          />
        </Row>

        <Row>
          <Form.Group as={Col}>
            <FormControl fullWidth sx={{ my: 1 }}>
              <Stack spacing={2} direction="row">
                <Button variant="contained" type="submit" className="red-bg red-button text-capitalize h-56">
                  Update
                </Button>
              </Stack>
            </FormControl>
          </Form.Group>
        </Row>
      </Form>
    </>
  );
};


export default EditLeadForm;
